import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ComboService,
  SalesOrderService,
  StockService
} from "../../../services/index";
declare var google;

@Component({
  selector: "payment-voucher-list",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./paymentVoucherList.html",
})
export class paymentVoucherList implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  brand: string;
  printPreview: any;
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  printData;
  noofpcs: number;
  box: boolean;
  shirt: boolean;
  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  viewList = ["CHEQUE RETURN", "PAYMENT ENTRY"];

  filter = {
    party_id: "",
    party_name: "",
    ref_no: "",
    order_from_date: "",
    order_to_date: "",
    view_type : ""
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "pay_id",
    orderDir: "DESC",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("checkReturnTemplate") checkReturnTemplate: TemplateRef<any>;
  @ViewChild("orderTemplate") orderTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("box_printTemplate") box_printTemplate: TemplateRef<any>;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private salesservice: SalesOrderService,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService,
    private comboservice: ComboService,
    private stockService: StockService

  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.getPartyList();
    this.agentCombo();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Ref no",
        prop: "ref_no",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "Ref Date",
        prop: "ref_date_formatted",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Party name",
        prop: "party_name",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 180,
        maxWidth: 180,
        width: 180,
      },
      {
        name: "Sales person",
        prop: "agent_name",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Payment mode",
        prop: "payment_mode",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Bank name",
        prop: "bank_name",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Bank ref no",
        prop: "bank_ref_no",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "Amount",
        prop: "amount",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "Sal.Per Comm",
        prop: "commission",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Action",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
      {
        name: "Check Return",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        cellTemplate: this.checkReturnTemplate,
      }
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 300);
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.party_name = "";
    this.filter.party_id = "";
    this.filter.ref_no = "";
    this.filter.view_type = "";
    this.filter.order_from_date = "";
    this.filter.order_to_date = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
 
    if (this.filter.party_name == "") {
      this.filter.party_id;
    }
    this.filterPanel.close();
    this.getOrderList();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }
  agentCombo() {
    let that = this;

    this.combo2Service.agentCombo().then((res: any) => {
      that.agentList = res.data;
      // setTimeout(function () {
      //     that.displayAgent('Agent', that.user.params.agent_id);
      // }, 200);
    });
  }

  chequeReturn(mode, row) {
    swal({
      title: "Are you sure to save this Cheque Return?",
      text:
        "You will not be able to recover this Payment saved" +
        " " +
        row["ref_no"] +
        "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Save it!",
      cancelButtonText: "No, keep it",
    })
      .then(() => {
        this.getPaymentVoucherDetails(mode, row);
      })
      .catch((dismiss) => {});
  }

  bsModalRef: BsModalRef;
  getPaymentVoucherDetails(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getOrderList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD PAYMENT VOUCHER",
          title: "ADD PAYMENT VOUCHER",
          tabParent: "SALES_PLAN",
          mode: mode,
          data: row,
          name: "ADD PAYMENT VOUCHER",
        },
      };
    } else {
    
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW PAYMENT VOUCHER",
          title: "VIEW PAYMENT VOUCHER",
          tabParent: "SALES_PLAN",
          mode: mode,
          data: row,
          name: "VIEW PAYMENT VOUCHER",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  getPartyList() {
    let params = {
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }
  onSelectParty(party) {
    this.partyList.forEach((element) => {
      if (party == element.name) {
        this.filter.party_id = element.genLedid;
      }
    });
  }
  // onSelectAgent(event) {
  //   this.filter.agent_id = event.agent_id;
  // }
  getOrderList(): void {
    if (this.filter.order_from_date) {
      this.filter.order_from_date = this.datePipe.transform(
        this.filter.order_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.order_to_date) {
      this.filter.order_to_date = this.datePipe.transform(
        this.filter.order_to_date,
        "yyyy-MM-dd"
      );
    }
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      from_date : this.filter.order_from_date,
      to_date : this.filter.order_to_date,
      party : this.filter.party_id,
      ref_no : this.filter.ref_no,
      view_type : this.filter.view_type

    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.salesservice
      .getPaymentVoucherDetails(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.total;
        that.orderList = res.data;
        for (let i = 0; i < that.orderList.length; i++) {
       
          that.orderList[i].ref_date_formatted = that.datePipe.transform(
            that.orderList[i].ref_date,
            "dd-MM-yyyy"
          );
        }
      });
  }

  deleteOrder(row: any): void {
    let that = this;
    row.tabevent = undefined;
    let params = {
      so_id: row.so_id,
    };
    swal({
      title: "Are you sure to delete this Order Details?",
      text:
        "You will not be able to recover this Order" + " " + row["so_no"] + "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.salesservice
          .delsalesOrder(params)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getOrderList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }

  boxprintModal(row) {
    this.brand = row.brand;
    let params = {
      br_id: row.so_id,
    };
    this.salesservice.boxprintModal(params).then((res: any) => {
      this.printPreview = res.data;
    });
  }

  printer() {
    this.noofpcs = 1;
    if ($("#box").is(":checked")) {
      this.box = true;
    } else {
      this.box = false;
    }
    if ($("#shirt").is(":checked")) {
      this.shirt = true;
    } else {
      this.shirt = false;
    }
    if (this.box == false && this.shirt == false) {
      swal("PLEASE SELECT ATLEAST ONE");
    } else {
      $("#box").prop("checked", false);
      $("#shirt").prop("checked", false);
    }
    let params = {
      noofpcs: this.noofpcs,
      box: this.box,
      shirt: this.shirt,
      brand: this.brand,
      designdet: JSON.stringify(this.printPreview),
    };
    this.stockService.print(params).then((res: any) => {});
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/paymentVoucher/paymentVoucherList.ts